/**
 * Description: Registers all stock capabilities on a CapabilityRegistry instance.
 * Usage: registerBuiltinCapabilities(registry) before BehaviorEngine.init.
 */
import { idle } from './capabilities/idle.js';
import { walk } from './capabilities/walk.js';
import { jump } from './capabilities/jump.js';
import { sit } from './capabilities/sit.js';
import { fall } from './capabilities/fall.js';
import { run } from './capabilities/run.js';
import { sleep } from './capabilities/sleep.js';
import { pee } from './capabilities/pee.js';

export function registerBuiltinCapabilities(registry) {
  registry.register('idle', idle);
  registry.register('walk', walk);
  registry.register('jump', jump);
  registry.register('sit', sit);
  registry.register('fall', fall);
  registry.register('run', run);
  registry.register('sleep', sleep);
  registry.register('pee', pee);
}
